import React from "react"
import { Box, Typography, Grid, Paper } from "@mui/material"
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined"
import SectionBox from "./SectionBox"

export default function ExportAnalyticsReports() {
    const reports = [
        {
            title: "Contractor Ratings",
            subtitle: "Compliance & performance metrics",
        },
        {
            title: "Violation Analysis",
            subtitle: "Detailed violation breakdown",
        },
        {
            title: "Full Analytics",
            subtitle: "Complete compliance dashboard",
        },
    ]

    return (
        <SectionBox
            icon={<DownloadOutlinedIcon sx={{ fontSize: 22, color: "#101828" }} />}
            title="Export Analytics Reports"
            titleSize="24px"
        >
            <Grid
                container
                sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    gap: "16px", // ↓ reduced spacing between buttons
                    justifyContent: "space-between",
                }}
            >
                {reports.map((r, i) => (
                    <Grid item xs={12} md={4} key={i}>
                        <Paper
                            elevation={0}
                            sx={{
                                border: "1px solid #E4E7EC",
                                borderRadius: "8px",
                                backgroundColor: "#F9FAFB",
                                padding: "1.5rem",
                                height: "100%",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                display: "flex", // ✅ center content
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                "&:hover": {
                                    backgroundColor: "#F4F3FF",
                                    borderColor: "#6A00FF",
                                    transform: "translateY(-2px)",
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    color: "#101828",
                                    fontSize: "15px",
                                    mb: "4px",
                                }}
                            >
                                {r.title}
                            </Typography>
                            <Typography sx={{ color: "#667085", fontSize: "13px" }}>
                                {r.subtitle}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </SectionBox>
    )
}
